import React from "react";
import { Wrapper } from "./IconStyle";
import { Tooltip } from "antd";

const MenuObject = ({ keyProps, Margin }) => {
  return (
    <Wrapper className="iconObject" style={{ marginRight: Margin }}>
      <Tooltip placement="right" title={keyProps}>
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="object_icon_active"
          style={{ display: "none" }}
        >
          <path
            d="M20.1667 7.81016V3.6485C20.1667 2.356 19.58 1.8335 18.1225 1.8335H14.4192C12.9617 1.8335 12.375 2.356 12.375 3.6485V7.801C12.375 9.10266 12.9617 9.616 14.4192 9.616H18.1225C19.58 9.62516 20.1667 9.10266 20.1667 7.81016Z"
            fill="#20A2A2"
          />
          <path
            d="M20.1667 18.1225V14.4192C20.1667 12.9617 19.58 12.375 18.1225 12.375H14.4192C12.9617 12.375 12.375 12.9617 12.375 14.4192V18.1225C12.375 19.58 12.9617 20.1667 14.4192 20.1667H18.1225C19.58 20.1667 20.1667 19.58 20.1667 18.1225Z"
            fill="#20A2A2"
          />
          <path
            d="M9.62504 7.81016V3.6485C9.62504 2.356 9.03837 1.8335 7.58087 1.8335H3.87754C2.42004 1.8335 1.83337 2.356 1.83337 3.6485V7.801C1.83337 9.10266 2.42004 9.616 3.87754 9.616H7.58087C9.03837 9.62516 9.62504 9.10266 9.62504 7.81016Z"
            fill="#20A2A2"
          />
          <path
            d="M9.62504 18.1225V14.4192C9.62504 12.9617 9.03837 12.375 7.58087 12.375H3.87754C2.42004 12.375 1.83337 12.9617 1.83337 14.4192V18.1225C1.83337 19.58 2.42004 20.1667 3.87754 20.1667H7.58087C9.03837 20.1667 9.62504 19.58 9.62504 18.1225Z"
            fill="#20A2A2"
          />
        </svg>

        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="object_icon"
        >
          <path
            d="M18.1225 10.3127H14.4192C12.5767 10.3127 11.6875 9.49683 11.6875 7.81016V3.6485C11.6875 1.96183 12.5858 1.146 14.4192 1.146H18.1225C19.965 1.146 20.8542 1.96183 20.8542 3.6485V7.801C20.8542 9.49683 19.9558 10.3127 18.1225 10.3127ZM14.4192 2.521C13.1908 2.521 13.0625 2.86933 13.0625 3.6485V7.801C13.0625 8.58933 13.1908 8.9285 14.4192 8.9285H18.1225C19.3508 8.9285 19.4792 8.58016 19.4792 7.801V3.6485C19.4792 2.86016 19.3508 2.521 18.1225 2.521H14.4192Z"
            fill="#454F5B"
          />
          <path
            d="M18.1225 20.8542H14.4192C12.5767 20.8542 11.6875 19.9558 11.6875 18.1225V14.4192C11.6875 12.5767 12.5858 11.6875 14.4192 11.6875H18.1225C19.965 11.6875 20.8542 12.5858 20.8542 14.4192V18.1225C20.8542 19.9558 19.9558 20.8542 18.1225 20.8542ZM14.4192 13.0625C13.3375 13.0625 13.0625 13.3375 13.0625 14.4192V18.1225C13.0625 19.2042 13.3375 19.4792 14.4192 19.4792H18.1225C19.2042 19.4792 19.4792 19.2042 19.4792 18.1225V14.4192C19.4792 13.3375 19.2042 13.0625 18.1225 13.0625H14.4192Z"
            fill="#454F5B"
          />
          <path
            d="M7.58087 10.3127H3.87754C2.03504 10.3127 1.14587 9.49683 1.14587 7.81016V3.6485C1.14587 1.96183 2.04421 1.146 3.87754 1.146H7.58087C9.42337 1.146 10.3125 1.96183 10.3125 3.6485V7.801C10.3125 9.49683 9.41421 10.3127 7.58087 10.3127ZM3.87754 2.521C2.64921 2.521 2.52087 2.86933 2.52087 3.6485V7.801C2.52087 8.58933 2.64921 8.9285 3.87754 8.9285H7.58087C8.80921 8.9285 8.93754 8.58016 8.93754 7.801V3.6485C8.93754 2.86016 8.80921 2.521 7.58087 2.521H3.87754Z"
            fill="#454F5B"
          />
          <path
            d="M7.58087 20.8542H3.87754C2.03504 20.8542 1.14587 19.9558 1.14587 18.1225V14.4192C1.14587 12.5767 2.04421 11.6875 3.87754 11.6875H7.58087C9.42337 11.6875 10.3125 12.5858 10.3125 14.4192V18.1225C10.3125 19.9558 9.41421 20.8542 7.58087 20.8542ZM3.87754 13.0625C2.79587 13.0625 2.52087 13.3375 2.52087 14.4192V18.1225C2.52087 19.2042 2.79587 19.4792 3.87754 19.4792H7.58087C8.66254 19.4792 8.93754 19.2042 8.93754 18.1225V14.4192C8.93754 13.3375 8.66254 13.0625 7.58087 13.0625H3.87754Z"
            fill="#454F5B"
          />
        </svg>
      </Tooltip>
    </Wrapper>
  );
};

export default MenuObject;
